export const AUTH_LOGIN = "auth_login";
export const AUTH_LOGOUT = "auth_logout";
export const AUTH_USER = "auth_user";
export const AUTH_REGISTER = "auth_register";
export const AUTH_UPDATE = "auth_update";
export const AUTH_SEND_MAIL = "auth_send_mail";
export const AUTH_RESET_PASSWORD = "auth_reset_password";

//recharge
export const AUTH_POST_RECHARGE = "auth_post_recharge";
export const AUTH_GET_INFO_RECHARGE = "auth_get_info_recharge";
export const AUTH_GET_HISTORY_RECHARGE = "auth_get_history_recharge";
export const AUTH_GET_HISTORY_COIN = "auth_get_history_coin";

export const COMMON_SET_SNACK = "common_setSnack";

export const FB_POST_GET_LIST_SEEDING  = "fb_post_ListSeeding";
export const GET_SEEDING_BONUS  = "fb_post_seeding_bonus";
export const POST_SEEDING_BONUS  = "fb_post_seeding_bonus_save";
export const UVIEW_POST_GET_LIST_SEEDING  = "uview_post_ListSeeding";
export const FB_POST_GET_LIST_REACTION  = "fb_post_ListReaction";
export const FB_POST_SAVE_PROCESS  = "fb_post_SaveProcess";
export const FB_POST_GET_LIST_ORDER  = "fb_post_ListOrder";
export const FB_JOB_CANCEL_ORDER  = "fb_job_cancel_order";
export const FB_JOB_CALCULATE  = "fb_job_calculate";
export const UVIEW_JOB_CALCULATE  = "uview_job_calculate";
export const FB_GET_POST_ID  = "fb_get_PostID";
export const FB_GET_PAGE_ID  = "fb_get_PageID";
export const FB_GET_PROFILE_ID  = "fb_get_ProfileID";
export const FB_GET_PROFILE_ID_BUFF  = "fb_get_ProfileIDBUFF";
export const FB_STREAM_GET_LIST_ORDER = "fb_stream_ListSeeding";
export const FB_STREAM_SAVE_PROCESS = "fb_stream_SaveProcess";
export const FB_REVIEW_SAVE_PROCESS = "fb_review_SaveProcess";
export const SYNC_DATA_FROM_FB = "fb_sync_data";
export const FB_JOB_SUCCESS_ORDER = "fb_success_data";
export const FB_JOB_EDIT_ORDER = "fb_edit_data";

export const FB_FAN_PAGE_SAVE_PROCESS  = "fb_fan_page_SaveProcess";
export const FB_GROUP_SAVE_PROCESS  = "fb_group_SaveProcess";
export const FB_LIKE_COMMENT_SAVE_PROCESS  = "fb_like_comment_SaveProcess";
export const FB_FOLLOW_SAVE_PROCESS  = "fb_follow_SaveProcess";
export const FB_RIP_ACCOUNT_HISTORY = "fb_rip_account_History";
export const FB_RIP_ACCOUNT_SAVE_PROCESS = "fb_rip_account_SaveProcess";

// INSTA
export const INSTA_LIKE_SAVE_PROCESS  = "insta_like_SaveProcess";
export const INSTA_FOLLOW_SAVE_PROCESS  = "insta_follow_SaveProcess";
export const INSTA_JOB_CANCEL_ORDER  = "insta_job_cancel_order";
export const INSTA_COMMENT_SAVE_PROCESS  = "insta_comment_SaveProcess";
export const INSTA_GET_LIST_ORDER  = "insta_ListOrder";
export const SYNC_DATA_FROM_INSTA = 'insta_sync';
export const INSTA_JOB_SUCCESS_ORDER = "insta_success_data";
export const INSTA_JOB_EDIT_ORDER = "insta_edit_data";
// VIP FB
export const VIP_LIKE_CLONE_SAVE_PROCESS  = "vip_like_clone_SaveProcess";
export const VIP_LIKE_MONTH_SAVE_PROCESS  = "vip_like_month_SaveProcess";
export const VIP_LIKE_MOUNT_SAVE_PROCESS  = "vip_like_mount_SaveProcess";
export const VIP_REACTION_MONTH_SAVE_PROCESS  = "vip_reaction_mount_SaveProcess";
export const VIP_COMMENT_MONTH_SAVE_PROCESS  = "vip_comment_mount_SaveProcess";
export const VIP_FACE_GET_SEEDING  = "vip_face_GetSeeding";
export const VIP_FACE_CALCULATE  = "vip_face_Calculate";
export const VIP_REACTION_FACE_CALCULATE  = "vip_reaction_face_Calculate";
export const VIP_FACE_LIST  = "vip_face_LISt";
export const VIP_FACE_LOG  = "vip_face_LOG";
export const VIP_CANCEL_ORDER  = "vip_cancel_order";

// TIKTOK
export const TIKTOK_REACTION_SAVE_PROCESS = "tiktok_like_SaveProcess";
export const TIKTOK_VIEW_SAVE_PROCESS = "tiktok_view_SaveProcess";
export const YOUTUBE_VIEW_SAVE_PROCESS = "youtube_view_SaveProcess";
export const FACEBOOK_VIEW_SAVE_PROCESS = "facebook_view_SaveProcess";
export const TIKTOK_FOLLOW_SAVE_PROCESS  = "tiktok_follow_SaveProcess";
export const TIKTOK_COMMENT_SAVE_PROCESS  = "tiktok_comment_SaveProcess";
export const TIKTOK_GET_LIST_ORDER = "tiktok_ListOrder";
export const TIKTOK_JOB_CANCEL_ORDER  = "tiktok_job_cancel_order";
export const SYNC_DATA_FROM_TIKTOK = 'tiktok_sync';
export const TIKTOK_JOB_SUCCESS_ORDER = "tiktok_success_data";
export const TIKTOK_JOB_EDIT_ORDER = "tiktok_edit_data";
export const UVIEW_GET_LIST_ORDER = "uview_list_order";
export const UVIEW_JOB_SUCCESS_ORDER = "uview_cacnel_order";
export const UVIEW_SYNC_DATA = 'uview_sync';

//  Config page
export const CONFIG_PAGE  = "config_page";

// seeding type
export const SEEDING_TYPE_MAINTAIN  = "seeding_type_maintain";
export const SEEDING_TYPE_MAINTAIN_BY_ID  = "seeding_type_maintain_by_id";

//instagram-vip
export const VIP_INSTAGRAM_CALCULATE  = "vip_instagram_Calculate";
export const VIP_LIKE_MONTH_INSTAGRAM_SAVE_PROCESS  = "vip_like_month_instagram_SaveProcess";
export const VIP_LIKE_MONTH_INSTAGRAM_UPDATE_PROCESS  = "vip_like_month_instagram_update_process";
export const VIP_COMMENT_MONTH_INSTAGRAM_SAVE_PROCESS  = "vip_comment_instagram_mount_SaveProcess";
export const VIP_LIKE_MONTH_INSTAGRAM_SUCCESS_ORDER = "vip_like_month_instagram_success_order";

export const VIP_INSTAGRAM_LOG  = "vip_instagram_log";


// Bot interaction
export const BOT_INTERACTION_GET_USER_FORM = 'bot_interaction_user_form'
export const BOT_INTERACTION_SAVE_ORDER = 'bot_interaction_save_order'
export const BOT_INTERACTION_GET_USER_COOKIE = 'bot_interaction_get_user_cookie'
export const BOT_INTERACTION_GET_LIST_PROXY = "bot_interaction_get_list_proxy";
export const BOT_INTERACTION_BUY_PROXY = "bot_interaction_buy_proxy";
export const BOT_INTERACTION_GET_LIST_PROXY_ORDER = "bot_interaction_get_list_proxy_order";
export const BOT_INTERACTION_GET_LIST_BOT_ORDER = "bot_interaction_get_list_bot_order";
export const BOT_INTERACTION_GET_DIARY = "bot_interaction_get_diary";
export const BOT_INTERACTION_EXTEND_DATE = "bot_interaction_extend_date";
export const BOT_INTERACTION_DELETE_ORDER = "bot_interaction_delete_order";
export const BOT_INTERACTION_UPDATE_COOKIE = "bot_interaction_update_cookie";
export const BOT_INTERACTION_STOP_ORDER = "bot_interaction_stop_order";
export const BOT_INTERACTION_START_ORDER = "bot_interaction_start_order";
export const BOT_INTERACTION_EXTEND_DATE_PROXY = "bot_interaction_extend_date_proxy";
export const BOT_INTERACTION_GET_IMAGE_THEME = "bot_interaction_get_image_theme";
export const BOT_INTERACTION_UPDATE_ORDER = "bot_interaction_update_order";
export const BOT_INTERACTION_GET_ORDER = "bot_interaction_get_order";
export const BOT_INTERACTION_GET_STICKER_IMAGE = "bot_interaction_get_sticker_image";


// bot spam
export const BOT_SPAM_GET_USER_FORM = 'bot_spam_user_form'
export const BOT_SPAM_SAVE_ORDER = 'bot_spam_save_order'
export const BOT_SPAM_GET_USER_COOKIE = 'bot_spam_get_user_cookie'
export const BOT_SPAM_GET_LIST_BOT_SPAM_ORDER = "bot_spam_get_list_bot_spam_order";
export const BOT_SPAM_GET_DIARY = "bot_spam_get_diary";
export const BOT_SPAM_EXTEND_DATE = "bot_spam_extend_date";
export const BOT_SPAM_DELETE_ORDER = "bot_spam_delete_order";
export const BOT_SPAM_UPDATE_COOKIE = "bot_spam_update_cookie";
export const BOT_SPAM_STOP_ORDER = "bot_spam_stop_order";
export const BOT_SPAM_START_ORDER = "bot_spam_start_order";


// customer level
export const CUSTOMER_LEVEL_PRICE_LIST = "customer_level_price_list";
export const CUSTOMER_LEVEL_PROFILE = "customer_level_profile";


// Timeline Notice
export const TIMELINE_NOTICE  = "timeline_notice";

// referral
export const REFERRAL_LIST_BANNER = 'referral_list_banner';
export const REFERRAL_LIST_PRESENTER = 'referral_list_presenter';
export const GET_PERCENT_PRESENTER = "get_percent_presenter";

// withdraw
export const WITHDRAW_LIST_METHOD = "withdraw_list_method";
export const WITHDRAW_DETAIL_FORM = "withdraw_detail_form";
export const WITHDRAW_POST_FORM = "withdraw_post_form";

//config_other_page
export const CONFIG_OTHER_PAGE = "config_other_page";

//Share Stream
export const SHARE_STREAM_GET_GROUP = "share_stream_get_group";
export const SHARE_STREAM_GET_STREAM = "share_stream_get_stream";
export const SHARE_STREAM_SAVE_ORDER = "share_stream_save_order";
export const SHARE_STREAM_GET_PRICE = "share_stream_get_price";

//ticket
export const TICKET_GET_LIST = 'ticket_get_list';
export const TICKET_GET_DETAIL = 'ticket_get_detail';
export const TICKET_POST_CREATE = 'ticket_post_create';
export const TICKET_POST_REPLY = 'ticket_post_reply';
export const TICKET_POST_UPDATE_STATUS = 'ticket_post_update_status';

//telegram
export const TELEGRAM_HISTORY = "telegram_history";
export const TELEGRAM_SAVE_PROCESS = "telegram_save_process";

//post group
export const POST_GROUP_GET_PRICE = "post_group_get_price";
export const POST_GROUP_SAVE_ORDER = "post_group_save_order";
export const POST_GROUP_GET_LOG = "post_group_get_log";

//report
export const REPORT_PAYMENT_ERROR = "report_payment_error";

//buff tây
export const BUFF_TAY_GET_PRICE = "buff_tay_get_price";
export const BUFF_TAY_SAVE_ORDER = "buff_tay_save_order";

//youtube
export const BUFF_LIKE_YOUTUBE_SAVE_ORDER = "buff_like_youtube_save_order";
export const BUFF_4K_VIEW_YOUTUBE_SAVE_ORDER = "buff_4k_view_youtube_save_order";

//tiktok vip like
export const TIKTOK_VIP_LIKE_SAVE_ORDER = "tiktok_vip_like_save_order";
export const VIP_TIKTOK_GET_LOG  = "vip_tiktok_get_log";